











import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import CaseApi from '@/api/CaseApi';
import {CaseItemCodesRetrieveResponse, CodeRetrieveResponse} from '@/model/CommonModel';
import CommonButton from '@/components/button/CommonButton.vue';

@Component({
    components: {CommonButton}
})
export default class NullFlavor extends Vue {
    @Prop({default: false}) private disabled: boolean;
    @Prop({default: null}) private value: string;
    @Prop({default: ''}) private itemId: string;
    private visible = false;
    private loading = false;
    
    private nullFlavors: CodeRetrieveResponse[] = [];
    
    get nullFlavor() {
        return this.value !== null && this.value !== ''
            ? this.value
            : 'NF';
    }
    
    get getItemId() {
        return (item: CodeRetrieveResponse) => {
            return `${this.itemId}-${item.codeValue}:${item.codeLabel}`;
        };
    }

    get label() {
        return (item: CodeRetrieveResponse) => {
            return `${item.codeValue}`;
        };
    }

    get isDisabled() {
        return this.disabled;
    }

    public loadNullFlavors() {
        if (this.nullFlavors.length > 0) {
            return;
        }

        this.loading = true;
        CaseApi.retrieveCaseItemNullFlavors(this.itemId)
               .then((res: CaseItemCodesRetrieveResponse) => {
                   this.nullFlavors = res.data ?? [];
               })
               .finally(() => this.loading = false);
    }
    
    public onClickNullFlavor(item: CodeRetrieveResponse) {
        this.$emit('nullFlavorSelected', item.codeValue);
        this.visible = false;
    }
}
